import { useEffect, useState } from "react";
import { API_URL } from "../../shared/api";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function useBackupUser() {
  const { state } = useLocation();
  const [ user, setUser ] = useState(state?.user);
  const { userId } = useParams();

  useEffect(() => {
    if (!user && userId) {
      fetch(`${API_URL}/users/${userId}`, { method: "GET" })
        .then(r => r.json())
        .then(setUser)
        .catch(err => console.error("Error fetching user:", err));
    }
  }, [user, userId]);

  return user;
}
